import { Component, EventEmitter, OnInit, Output, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

import { DialogLightComponent } from '../../../ui/dialog-light/dialog-light';

import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { AuthService } from '../../../providers/auth/auth.service';
import { CustomerProvider } from '../../../providers/customer/customer';
import { UserProvider } from '../../../providers/user/user';
import { I18nProvider } from '../../../providers/i18n/i18n';

@Component({
  selector: 'component-customer-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class CustomerProgramsComponent implements OnInit {
  protected headers: any;
  @Input() studentData: any = null;
  @Input() studentSelected: any = null;
  @Input() user: any = null;
  @Input() programs: any = null;

  @Output() closePrograms = new EventEmitter<void>();
  @Output() setUserListUpdated = new EventEmitter();

  modernSearch = '';
  modernFilter = 'Todos';
  modernFilters = ['Todos', 'Iniciante', 'Intermediário', 'Avançado', 'Não enviados'];
  selectedPrograms = new Set<any>();
  sending = false;
  removingProgramId: any = null;

  get filteredPrograms(): any[] {
    const term = this.helpers.removeDiacritics(this.modernSearch.trim()).toLowerCase();
    return (this.programs || []).filter(program => {
      const text = [this.helpers.returnTranslation(program)]
        .concat((program.goals || []).map(goal => this.helpers.returnTranslation(goal))).join(' ');
      return (!term || this.helpers.removeDiacritics(text).toLowerCase().includes(term)) &&
        (this.modernFilter === 'Todos' ||
          (this.modernFilter === 'Não enviados' ? !program.student : program.difficulty_level === this.modernFilter));
    });
  }

  toggleSelection(program: any) {
    if (this.sending || !this.studentSelected || program.student) return;
    if (this.selectedPrograms.has(program.id)) this.selectedPrograms.delete(program.id);
    else this.selectedPrograms.add(program.id);
  }

  async sendPrograms() {
    if (this.sending || !this.studentSelected || !this.selectedPrograms.size) return;
    const studentId = this.studentData.id;
    const studentName = this.studentData.name;
    const pending = (this.programs || []).filter(p => this.selectedPrograms.has(p.id) && !p.student);
    this.sending = true;
    let sent = 0;
    let latestResponse: any;
    try {
      for (const program of pending) {
        latestResponse = await this.studentProv.admCustomerToggleProgram({cid: studentId, pid: program.id});
        sent++;
        if (this.studentData.id === studentId) {
          program.student = 1;
          this.selectedPrograms.delete(program.id);
        }
      }
    } catch (error) {
      this.toastr.error('Não foi possível concluir o envio. Os programas pendentes continuam selecionados para tentar novamente.', '', this.helpers.toastrCfgs);
    } finally {
      this.sending = false;
      if (latestResponse) this.setUserListUpdated.emit(latestResponse);
      if (sent) this.toastr.success(sent + (sent === 1 ? ' programa enviado para ' : ' programas enviados para ') + studentName, '', this.helpers.toastrCfgs);
    }
  }

  async removeProgram(program: any) {
    if (this.sending || this.removingProgramId !== null || !this.studentSelected || !this.studentData || !program.student) return;
    const studentId = this.studentData.id;
    const studentName = this.studentData.name;
    this.removingProgramId = program.id;
    try {
      const response = await this.studentProv.admCustomerToggleProgram({cid: studentId, pid: program.id});
      if (this.studentData && this.studentData.id === studentId) {
        program.student = 0;
        this.selectedPrograms.delete(program.id);
      }
      this.setUserListUpdated.emit(response);
      this.toastr.success('Programa removido de ' + studentName, '', this.helpers.toastrCfgs);
    } catch (error) {
      this.toastr.error('Não foi possível remover o programa. Tente novamente.', '', this.helpers.toastrCfgs);
    } finally {
      this.removingProgramId = null;
    }
  }

  loading: boolean = false;
  totalPrograms: number = 0;

  totalItens2 = { count: 0 };
  maxItens2: number = 30;
  page2: number = 0;
  totalPages: number = 0;
  searchProgram: any = {
    name: <string> '',
    premium: <any> '',
    published: <any> '',
    workout_muscle_ids: <any> [],
    workout_equip_ids: <any> [],
    workout_method_ids: <any> [],
  };
  showHistory: boolean = false;

  PAGE: any;
  STRINGS: any;
  ismobile: boolean;

  constructor(
    public toastr: ToastrService,
    public auth: AuthService,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public i18n: I18nProvider,
    private router: Router,
    private device: DeviceDetectorService,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('CustomerProgramsComponent');
    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};
  }
  ngOnInit() {
    // console.log('OnInit - componente.customer.programs');
    // console.log(this.programs);
    this.totalItens2.count = this.programs.length;
    this.totalPrograms = this.programs.length;
    this.totalPages = Math.ceil(this.totalItens2.count/this.maxItens2);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentData && (!changes.studentData.previousValue ||
        changes.studentData.previousValue.id !== this.studentData.id)) {
      this.selectedPrograms.clear();
      this.modernSearch = '';
      this.modernFilter = 'Todos';
    }
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 400);
  }


  toggleClass(item: any) {
    item.active = !item.active;
  }

  toggleActiveProgram(id: number) {
    if (this.studentSelected) {
      // console.log('Student ID:' + this.studentForm.value.id);
      // console.log('Program ID:' + id);
      const data = {
        cid: this.studentData.id,
        pid: id
      };
      this.studentProv.admCustomerToggleProgram(data).then(
        (res: any) => {
          // this.loading = false;
          // this.students = res.customers;
          this.setUserListUpdated.emit(res);
          this.toastr.success('(' + this.studentData.name.split(' ')[0] + ') ' + this.PAGE.lista_programas_atualizada, '', this.helpers.toastrCfgs);
        },
        (err: any) => {
          this.toastr.error(err, '', this.helpers.toastrCfgs);
          this.loading = false;
        }
      );

    }
  }

  helpSendPrograms() {
    let msg = this.PAGE.ajuda_enviar_programas;

    const dialogRef = this.dialog.open(DialogLightComponent, { width: '360px', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }

  searchProgramChange() {
    this.totalPages = Math.ceil(this.totalItens2.count/this.maxItens2);
  }

  removePagination(page: number = 0) {
    const pageTarget = this.page2 - page;
    this.changePagination(pageTarget);
  }

  addPagination(page: number = 0) {
    const pageTarget = this.page2 + page;
    this.changePagination(pageTarget);
  }

  changePagination(page: number = 0) {
    this.loading = true;

    this.page2 = page;
    if (page <= 0) {
      // console.log('page <= 0');
      this.page2 = 0;
    }
    if (page >= this.totalPages) {
      // console.log('page >= this.totalPages');
      this.page2 = this.totalPages - 1;
    }

    setTimeout(() => {
      this.loading = false;
    }, 250);
  }

  selectProgram(pid: any = 0) {
    this.ismobile = this.device.isMobile();

    if (this.ismobile) {
      this.router.navigate(['professor/programas'], { skipLocationChange: true, queryParams: { pid: pid } });
    } else {
      this.router.navigate([], { skipLocationChange: true, queryParams: { pid: pid } }).then(_result => {  
        window.open('professor/programas?pid='+pid, '_blank', 'popup=true,width=1282,height=760'); 
      });    
    }
  }

}
